import { Light, HemisphereLight, DirectionalLight } from 'three';
import { EditableFields, EditableObject } from './fields';

export namespace LightsFields {
    const commons = [
        'visible',
        'color',
        'intensity',
        'position',
        'rotation',
        'scale',
    ] as const;

    export const Directional: ReadonlyArray<EditableFields<DirectionalLight>> = commons;
    export const Ambient: ReadonlyArray<EditableFields<HemisphereLight>> = [
        ...commons,
        'groundColor',
    ];

    type AnyLightFields = typeof Directional | typeof Ambient;
    type AnyLight = DirectionalLight | HemisphereLight;

    export type Representation = {
        [P in keyof AnyLight]?: P extends AnyLightFields[number]
            ? EditableFields.RepresentationOf<AnyLight[P]>
            : never;
    };

    export namespace Abstract {
        export type Directional = EditableObject<DirectionalLight, typeof Directional>;
        export type Hemisphere = EditableObject<HemisphereLight, typeof Ambient>;
    }

    export function getAllowedFields<T extends Light = Light>(obj: T) {
        if (!(obj instanceof Light) || !obj.isLight) {
            return null;
        }

        if (obj instanceof DirectionalLight) {
            return Directional as ReadonlyArray<EditableFields<T>>;
        }

        if (obj instanceof HemisphereLight) {
            return Ambient as ReadonlyArray<EditableFields<T>>;
        }

        return null;
    }
}
